import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {UserService} from 'src/shared/services/user/user.service';

@Component({
  selector: 'app-form-login',
  templateUrl: './form-login.component.html',
  styleUrls: ['./form-login.component.scss']
})
export class FormLoginComponent implements OnInit {
  public form: FormGroup;
  @Input() error: string;
  @Input() loading: boolean;

  @Output()
  connect = new EventEmitter();
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private user: UserService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      pseudo: ['', Validators.required],
      pass: ['', Validators.required]
    });
  }

  onLogin() {
    this.connect.emit(this.form.value);
  }

  onForgotPass() {
    this.router.navigate(['/', 'forgot-password']);
  }
}
